(function () {
  const currentSection = document.currentScript.parentElement;
  const initSection = (section) => {
    if (
      !section ||
      !section.classList.contains("section-image-parallax-with-text")
    )
      return;
    initParallax(section);
    initImageAnimation(section);
    initSubheadingAnimation(section);
    initTextAnimation(section);
  };
  const initParallax = (section) => {
    const PARALLAX_SELECTOR = ".image-parallax";
    let items = [];
    let ticking = false;
    const collectItems = () => {
      section.querySelectorAll(PARALLAX_SELECTOR).forEach((elem) => {
        if (items.find((i) => i.el === elem)) return;
        items.push({
          el: elem,
          propertyValue: parseFloat(elem.dataset.parallaxPropertyValue) || 0,
          steps: elem.dataset.parallaxSteps || null,
          direction: elem.dataset.parallaxDirection || "down",
        });
        elem.style.visibility = "visible";
      });
    };
    const updatePositions = () => {
      const scrollY = window.pageYOffset;
      const windowHeight = window.innerHeight;
      items.forEach((item) => {
        const rect = item.el.getBoundingClientRect();
        const elementTop = rect.top + scrollY;
        const elementHeight = rect.height;
        const elementStart = elementTop - windowHeight;
        const elementEnd = elementTop + elementHeight;
        const scrollPosition = Math.max(0, scrollY - elementStart);
        const maxScroll = elementEnd - elementStart;
        let scrollPercent = (scrollPosition / maxScroll) * 100;
        scrollPercent = Math.max(0, Math.min(100, scrollPercent));
        let calculatedValue = 0;
        if (item.steps) {
          const [stepStart, stepEnd] = item.steps.split(",").map(Number);
          if (scrollPercent >= stepStart && scrollPercent <= stepEnd) {
            const stepRange = stepEnd - stepStart;
            const stepProgress = (scrollPercent - stepStart) / stepRange;
            calculatedValue = item.propertyValue * stepProgress;
          } else if (scrollPercent > stepEnd) {
            calculatedValue = item.propertyValue;
          }
        } else {
          calculatedValue = (item.propertyValue * scrollPercent) / 100;
        }
        const directedValue =
          item.direction === "up"
            ? item.propertyValue - calculatedValue
            : calculatedValue;
        item.el.style.transform = `translateX(-50%) translateY(${directedValue}px)`;
      });
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(updatePositions);
        ticking = true;
      }
    };
    if (!section.querySelector(PARALLAX_SELECTOR)) return;
    collectItems();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", () => {
      items = [];
      collectItems();
      updatePositions();
    });
    updatePositions();
  };
  const initImageAnimation = (section) => {
    const CONFIG = {
      stepDelay: 250,
      threshold: 0.1,
      rootMargin: "50px",
    };
    const ANIMATED_IMAGE_SELECTOR =
      '.image-parallax-with-text__image-inner-wrapper[data-has-image-animation="true"]';
    const animatedImages = section.querySelectorAll(ANIMATED_IMAGE_SELECTOR);
    if (!animatedImages.length) return;
    const animateImages = () => {
      animatedImages.forEach((image, index) => {
        image.classList.remove("bounceIn", "visible");
        setTimeout(() => {
          image.classList.add("bounceIn", "visible");
        }, CONFIG.stepDelay * (index + 1));
      });
    };
    const rect = section.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      animateImages();
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateImages();
            observer.unobserve(entry.target);
          }
        });
      }, CONFIG);
      observer.observe(section);
    }
  };
  const initSubheadingAnimation = (section) => {
    const items = section.querySelectorAll(
      ".image-parallax-with-text__subheading-wrapper--animation-container"
    );
    if (!items.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.5) {
            const el = entry.target;
            requestAnimationFrame(() => {
              el.classList.add("visible");
              el.querySelector(
                ".image-parallax-with-text__line"
              )?.classList.add("animated");
            });
            observer.unobserve(el);
          }
        });
      },
      {
        threshold: 0.5,
        rootMargin: "300px 0px",
      }
    );
    items.forEach((el) => observer.observe(el));
  };
  const initTextAnimation = (section) => {
    const animatedText = section.querySelector(
      ".image-parallax-with-text__main-text.animated-text"
    );
    if (animatedText) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.dataset.animationReady = "true";
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.3,
          rootMargin: "50px",
        }
      );
      observer.observe(animatedText);
    }
  };
  initSection(currentSection);
  document.addEventListener("shopify:section:load", (e) => {
    initSection(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    initSection(e.target);
  });
})();
